import {AfterViewInit, Component, OnDestroy, OnInit} from "@angular/core";
import {FormControl} from "@angular/forms";
import {IFcDropdownSelectOption} from "../../../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {Product} from "../product";
import {ActivatedRoute, Router} from "@angular/router";
import {SearchByPropertyPipe} from "../../../shared/pipes/search-by-property.pipe";
import {FilterProductsByStatePipe} from "../filter-products-by-state.pipe";
import {Website} from "../website";
import {Subscription} from "rxjs";
import {SortProductsByFreeInstalledPipe} from "../sort-products-by-free-installed.pipe";
import {Permissions} from "../../../user/permissions";
import {Utils} from "../../../shared/utils/utils";
import {PageLoadingBarService} from '../../../shared/services/page-loading-bar/page-loading-bar.service';
import {AvailablePluginsComponent} from "./available-plugins/available-plugins.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserService} from '../../../user/user.service';
import {UserSubscription, UserSubscriptionIds} from '../../../user/user-subscription';
import {ProductService} from '../product.service';
import {WebsiteService} from '../../website.service';
import {ConfirmDialogComponent} from "../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {TextUtils} from "../../../shared/utils/text-utils";
import {animate, style, transition, trigger} from "@angular/animations";
import {DbStoreState} from '../../../store';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {ProductActionService} from "../product-action.service";
import {ActivityAction, ActivityStatus, IActivity} from '../../../activities/activity';
import {Location} from '@angular/common';
import {User} from "../../../user/user";

import {DbResponse} from "../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {ProductUpdateHistory} from "../productUpdateHistory";
import {TypeUtils} from "../../../shared/utils/type-utils";
import {Observable} from 'rxjs';
import {SortByPipe} from "../../../shared/pipes/sort-by.pipe";
import {MultisiteActionConfirmDialogComponent} from "../../../shared/components/dialogs/mulitiste-action-confirm-dialog/multisite-action-confirm-dialog.component";
import {UserSubscriptionType} from "../../../user/user-subscription";
import {TypeFormAnswers} from "../../../add-website/typeFormAnswers";
import features from "./plugins-features.json";
import {filter, first, switchMap} from "rxjs/operators";

@Component({
    selector: 'db-plugins',
    templateUrl: './plugins.component.html',
    styleUrls: ['./plugins.component.scss'],
    providers: [SortProductsByFreeInstalledPipe, FilterProductsByStatePipe],
    animations: [
        trigger('productItemAnimation', [
            transition("void => true", [
                style({
                    maxHeight: '0',
                    overflow: 'hidden'
                }),
                animate('500ms ease-out', style({
                    maxHeight: '200px',
                    overflow: 'hidden'
                })),
            ]),
            transition('true => void', [
                style({
                    maxHeight: '200px',
                    overflow: 'hidden'
                }),
                animate('500ms 1000ms ease-out', style({
                    maxHeight: '0',
                    overflow: 'hidden'
                })),
            ]),
        ]),
    ],
    standalone: false
})
export class PluginsComponent implements OnInit, OnDestroy, AfterViewInit {

  public ActivityAction: any = ActivityAction;

  private subscriptions: Subscription[];

  public selectAll: FormControl;

  public bulkAction: FormControl;
  public bulkActionOptions: IFcDropdownSelectOption[];

  public searchTerm: FormControl;

  public filterBy: FormControl;

  public itemsView: FormControl;

  public userPermissions: Permissions;

  public website: Website;
  public pluginsScope: string;
  public plugins: Product[];
  public pluginsForSchedule: Product[];

  public filteredPlugins: Product[];

  private _userSubscriptions: UserSubscription[];
  public currentSubscription: UserSubscription;
  public hideFilterBar: boolean = false;

  public updatingProductsList: boolean;

  public websiteConnected: boolean;
  public hasHostingBanner: any;
  public user: User;

  public scheduleCronExpression: string;
  public scheduleEnabled: boolean;
  public scheduleWithBackupEnabled: boolean;
  public pluginsScheduleLoading: boolean;
  public backupPlugin: Product;
  public selectAllForSchedule: FormControl;
  public pluginUpdateHistory: ProductUpdateHistory[] = [];
  public ongoingActivity$: Observable<IActivity[]>;
  public pluginListUpdateLoading: boolean;

  public sortDirectionClassName: string = "db-sort-direction-asc";
  private sortByDefaultValue: string = "name";
  private sortDirectionDefault: string = "asc";
  public sortBy: FormControl;
  public sortDirection: FormControl;
  public ongoingThemeActivities: any;
  private _userLocalStorage: any;


  public firstInfoLink: string = "https://help.10web.io/hc/en-us/articles/360010815479-Plugins-Scheduled-Updates";
  public secondInfoLink: string = "https://help.10web.io/hc/en-us/articles/360016113871-Installing-plugins-in-10Web-Dashboard";
  public thirdInfoLink: string = "https://help.10web.io/hc/en-us/articles/360024909212-Installing-premium-10Web-plugins-on-your-website";
  public fourthInfoLink: string = "https://help.10web.io/hc/en-us/articles/360016173952-Installing-extensions-in-10Web-Dashboard";
  public UserSubscriptionType: any = UserSubscriptionType;
  public demoUser: boolean = false;
  public features: string[] = [];
  public companyName: string = 'Dashboard';

  constructor(
    private _router: Router,
    private _location: Location,
    private _route: ActivatedRoute,
    private _store: Store<DbStoreState>,
    private _dialogService: DialogService,
    private _productService: ProductService,
    private _searchByPropertyPipe: SearchByPropertyPipe,
    private _sortPipe: SortByPipe,
    private _filterProductsByStatePipe: FilterProductsByStatePipe
  ) {}

  ngOnInit(): void {
    this.user = this._route.snapshot.parent.parent.data['user'];
    this._userLocalStorage = this._route.snapshot.parent.parent.data['userLocalStorage'];
    this.hasHostingBanner = localStorage.getItem("showConnectBanner" + this.user.id);
    this.userPermissions = this._route.snapshot.parent.parent.data['user'].permissions;
    this.website = this._route.snapshot.parent.parent.data['website'];
    this.pluginsScope = this._route.snapshot.url[0].path;
    this.selectAllForSchedule = new FormControl('');
    this._getCompanyInfo();

    const queryParams: any = (<any>this._route.queryParams).value;
    const websiteConnected = queryParams.website_connected;
    setTimeout(() => {
      this.websiteConnected = websiteConnected;
    }, 1000);
    const queryParamsIndex: number = this._router.url.indexOf('?');

    if (queryParamsIndex !== -1) {
      this._location.replaceState(this._router.url.substring(0, queryParamsIndex));
    }
    this.initFilters();

    this._userSubscriptions = this._route.snapshot.parent.data['subscriptions'];
    this.currentSubscription = this._route.snapshot.parent.data['subscription'];
    this.demoUser = Utils.isDemoUser(this.currentSubscription, this.user);
    this.initBulkActions();

    this.ongoingActivity$ = this._store.select(fromStore.getOngoingActivities);
    this.ongoingActivity$
      .subscribe((data): void => {
        if (data) {
          const ongoingPluginsActivities = data.filter((activity): boolean => this.website && activity && activity.websiteId === this.website.id && activity.meta && activity.meta.product_data && activity.meta.product_data.type === "plugin" && !(activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED));
          this.ongoingThemeActivities = data.filter((activity): boolean => this.website && activity && activity.websiteId === this.website.id && activity.meta && activity.meta.product_data && activity.meta.product_data.type && activity.meta.product_data.type === "theme" && !(activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED));
          if ( ongoingPluginsActivities && ongoingPluginsActivities.length) {
            this.pluginListUpdateLoading = true;
          }
          else {
            this.pluginListUpdateLoading = false;
          }
        }

      });

    if (this.user && this.user.signUpFor && this.user.signUpFor.Role && this.user.signUpFor.Role.id
      && localStorage.getItem('dbOnboardingPassed' + this.user.id) !== null
      && TypeUtils.isNull(this.user.signUpFor.WhoBuilds) && this.user.signUpFor.BuildingFor && this.user.signUpFor.BuildingFor.id !== TypeFormAnswers.BUILD_MY_CLIENT
      && this.currentSubscription && this.currentSubscription.subscriptionId === UserSubscriptionIds.TRIAL
      && ( ![TypeFormAnswers.AGENCY, TypeFormAnswers.FREELANCE].includes(this.user.signUpFor.Role.id) ) ) {
    }

    this.addEventHandlers();
  }

  ngAfterViewInit() {
  }

  private initBulkActions(): void {
    this.selectAll = new FormControl('');

    this.bulkAction = new FormControl('');
    if (this.pluginsScope === 'installed') {
      this.bulkActionOptions = [
        {
          value: '',
          label: '-Bulk Action-'
        },
        {
          value: ActivityAction.ACTIVATE,
          label: 'Activate'
        },
        {
          value: ActivityAction.DEACTIVATE,
          label: 'Deactivate'
        },
        {
          value: ActivityAction.UPDATE,
          label: 'Update'
        },
        {
          value: ActivityAction.DEACTIVATE_DELETE,
          label: 'Delete'
        }
      ];
    }
    else {
      this.bulkActionOptions = [
        {
          value: '',
          label: '-Bulk Action-'
        },
        {
          value: ActivityAction.INSTALL_ACTIVATE,
          label: 'Install'
        }
      ];
    }
  }

  private initFilters(): void {

    this.sortBy = new FormControl(this.sortByDefaultValue);
    this.sortDirection = new FormControl(this.sortDirectionDefault);

    this.searchTerm = new FormControl('');

    this.filterBy = new FormControl('active');

    this.itemsView = new FormControl('list');

  }

  private filterPlugins(): void {
    this.hideFilterBar = false;

    let filteredPlugins: Product[] = this._filterProductsByStatePipe.transform(this.plugins, this.filterBy.value);
    filteredPlugins = <Product[]>this._searchByPropertyPipe.transform(filteredPlugins, {'title': this.searchTerm.value, 'description': this.searchTerm.value});
    filteredPlugins = Utils.sort(filteredPlugins, (a: Product, b: Product): number => {
      if (this.pluginsScope === 'installed') {
        return a && b && (a.active === b.active ? 0 : (b.active && !a.active ? 1 : -1));
      }
      else {
        return a && b && (a.installed === b.installed ? 0 : (a.installed && !b.installed ? 1 : -1));
      }
    });
    filteredPlugins = Utils.sort(filteredPlugins, (a: Product, b: Product): number => {
      if (b.hasPaidVersion) {
        if (a.hasPaidVersion) {
          if (b.paidVersionInstalled && !a.paidVersionInstalled) {
            return -1;
          }
          else if (!b.paidVersionInstalled && a.paidVersionInstalled) {
            return 1;
          }
          return 0;
        }
        else {
          return 1;
        }
      }
      else {
        if (a.hasPaidVersion) {
          return -1;
        }
        else {
          return 0;
        }
      }
    });
    if (this.searchTerm.value === "" && !filteredPlugins.length) {
      this.hideFilterBar = true;
    }
    this.filteredPlugins = filteredPlugins;
  }

  private addEventHandlers(): void {
    this.subscriptions = [];

    this._store.select(fromStore.getWebsiteBackupPlugin(this.website.id))
      .subscribe((backupPlugin): void => {
        if (backupPlugin) {
          this.backupPlugin = backupPlugin;
        }
      });

    this.subscriptions.push(this._store.select(fromStore.getWebsitePluginsAndExtensions(this.website.id)).subscribe((plugins: Product[]) => {
        if (this.plugins && this.plugins.length) {
          for (let i = 0; i <= plugins.length; i++) {
            if (this.plugins[i] && plugins[i]) {
              if ( plugins[i].slug === this.plugins[i].slug && plugins[i].active === this.plugins[i].active && plugins[i].installed === this.plugins[i].installed ) {
                plugins[i].selected = this.plugins[i].selected;
              }
            }
          }
        }
        this.plugins = plugins;
        this.pluginsForSchedule = TypeUtils.cloneDeep(plugins);

        // Replace 10Web with company name in plugin data
        this.pluginsForSchedule = this.pluginsForSchedule.map(plugin => {
          if (plugin.title) {
            plugin.title = plugin.title.replace(/10Web/gi, this.companyName);
          }
          if (plugin.description) {
            plugin.description = plugin.description.replace(/10Web/gi, this.companyName);
          }
          if (plugin.author) {
            plugin.author = plugin.author.replace(/10Web/gi, this.companyName);
          }
          return plugin;
        });

        this.getSchedulePlugins();
        this.getPluginUpdateHistory();
        this.filterPlugins();

    }));

    this.subscriptions.push(this.searchTerm.valueChanges.subscribe((): void => {
      this.filterPlugins();
    }));

    this.subscriptions.push(this.filterBy.valueChanges.subscribe((): void => {
      this.updatingProductsList = true;
      setTimeout(() => {
        this.filterPlugins();

        setTimeout(() => {
          this.updatingProductsList = false;
        });
      });
    }));

    this.subscriptions.push(this.itemsView.valueChanges.subscribe((): void => {
      localStorage.setItem('dbProductItemView', this.itemsView.value);
    }));

    this.subscriptions.push(this.sortBy.valueChanges.subscribe((): void => {
      this.filterHistory();
    }));
  }

  private filterHistory() {
    let filterUpdateHistory = this.pluginUpdateHistory;
    filterUpdateHistory = <any>this._sortPipe.transform(filterUpdateHistory, this.sortBy.value, this.sortDirection.value);
    this.pluginUpdateHistory = filterUpdateHistory;
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  public getSchedulePlugins(): void {
    this.pluginListUpdateLoading = true;
    this._productService.getSchedulePlugins(this.website.id)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {

        if (response.success) {
          if (response.data) {
            const data = response.data;
            this.scheduleEnabled = data.schedule;
            this.scheduleCronExpression = data.cron_expression ? data.cron_expression : '00 00 * * 1';
            this.scheduleWithBackupEnabled = data.backup;
            this.pluginsForSchedule.map( (plugin) => {
              if (plugin.origin === '10web') {
                if (data.tenweb_products.length && data.tenweb_products.includes(plugin.productId)) {
                  plugin.selected = true;
                }
              }
              else {
                if (data.wp_products.length && data.wp_products.includes(plugin.slug)) {
                  plugin.selected = true;
                }
              }
            });
          }
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this.pluginListUpdateLoading = false;
      });
  }

  public getPluginUpdateHistory(): void {
    this._productService.getPluginUpdateHistory(this.website.id)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {

        if (response.success) {
          if (response.data) {
            const data = response.data;
            this.pluginUpdateHistory = data;
          }
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private removeEventHandlers(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this.subscriptions = null;
  }

  public toggleAllItemsSelected(selected: boolean): void {
    this.filteredPlugins.forEach((plugin: Product): void => {
      plugin.selected = selected;
    });
  }

  public onItemToggled(): void {
    this.updateSelectAllState();
  }

  private updateSelectAllState(): void {
    this.selectAll.setValue(this.filteredPlugins.length && !this.filteredPlugins.find((plugin: Product): boolean => !plugin.selected));
  }

  public applyBulkAction(bulkaction, deactivate): void {
    const bulkActionItems: Product[] = this.getBulkActionItems(bulkaction === ActivityAction.DEACTIVATE_DELETE && deactivate && this.filterBy.value !== "all" ? ActivityAction.DEACTIVATE : bulkaction);
    let network = 0;

    if (bulkaction) {
      if (bulkActionItems.length) {
        if (bulkaction === ActivityAction.DEACTIVATE_DELETE && deactivate) {
          this.showConfirmDeactivateAndDeleteDialog().then((confirmed: boolean): void => {
            if (confirmed) {
              if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
                network = 1;
              }
              this.dispatchActions(network, ActivityAction.DEACTIVATE_DELETE, bulkActionItems);
              this.toggleAllItemsSelected(false);
              this.updateSelectAllState();
            }
          });
        }
        else {
          if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
            this.openConfirmationDialog(network, bulkaction, bulkActionItems);
          }
          else {
            this.dispatchActions(network, bulkaction, bulkActionItems);
          }
          this.toggleAllItemsSelected(false);
          this.updateSelectAllState();
        }
      }
    }
    else {
      if (this.bulkAction.value && bulkActionItems.length) {
        if (this.website.isNetwork || (!this.website.isNetwork && this.website.parentId)) {
          this.openConfirmationDialog(network, this.bulkAction.value, bulkActionItems);
        }
      }
      else {
        this.dispatchActions(network, this.bulkAction.value, bulkActionItems);
      }

      this.toggleAllItemsSelected(false);
      this.updateSelectAllState();
    }
  }

  private dispatchActions(network, action, product) {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: product,
      action: action,
      network: network
    }));
  }

  private openConfirmationDialog(network, action, product) {
    let headerText;
    let messageText;
    let singleSiteButtonText;
    let multisiteButtonText;
    switch (action) {
      case ActivityAction.DEACTIVATE:
        headerText = 'text_multisiteDeactivate.header';
        messageText = 'text_multisiteDeactivate.message';
        singleSiteButtonText = 'text_deactivate';
        multisiteButtonText = 'text_networkDeactivate';
        break;
      case ActivityAction.ACTIVATE:
        headerText = 'text_multisiteActivate.header';
        messageText = 'text_multisiteActivate.message';
        singleSiteButtonText = 'text_activate';
        multisiteButtonText = 'text_networkActivate';
        break;
      case ActivityAction.UPDATE:
        headerText = 'text_updatePlugin';
        messageText = 'text_confirmUpdateAll';
        singleSiteButtonText = 'text_updateLater';
        multisiteButtonText = 'text_update';
        break;
      default:
    }
    this._dialogService
      .addDialog(MultisiteActionConfirmDialogComponent, {
        header: TextUtils.getText(headerText),
        message: TextUtils.getText(messageText),
        singleSiteButtonText: TextUtils.getText(singleSiteButtonText),
        multisiteButtonText: TextUtils.getText(multisiteButtonText)
      })
      .subscribe((confirmed: string|boolean) => {
        if (confirmed) {
          if (confirmed === 'network') {
            network = 1;
          }
          this.dispatchActions(network, action, product);
        }
      });
  }

  private getBulkActionItems(bulkaction): Product[] {
    const bulkAction = bulkaction ? bulkaction : this.bulkAction.value;
    return this.filteredPlugins.reduce((bulkActionItems: any[], plugin: Product): number[] => {
      const canApplyAction = this.filterBy.value === "all" ?  plugin.canApplyAction(bulkAction) : true;
      if (plugin.selected && ( canApplyAction || plugin.canApplyAction(bulkAction) ) ) {
        bulkActionItems.push(plugin);
      }
      return bulkActionItems;
    }, []);
  }

  private showConfirmDeactivateAndDeleteDialog(): Promise<boolean> {
    return new Promise<boolean>((resolve: any, reject: any): void => {
      this._dialogService
        .addDialog(ConfirmDialogComponent, {
          header: TextUtils.getText('text_confirmDeactivateAndDeletePlugin.header'),
          message: TextUtils.getText(this.website.parentId ? 'text_confirmDeactivateAndDeletePlugin.messageNetwork' : 'text_confirmDeactivateAndDeletePlugin.message'),
          cancelButtonText: TextUtils.getText('text_cancel'),
          confirmButtonText: TextUtils.getText('text_deactivateDelete')
        })
        .subscribe((confirmed: boolean) => {
          resolve(confirmed);
        });
    });
  }

  public onPluginStateChange($event): void {
    this.toggleAllItemsSelected(false);
    this.updateSelectAllState();
    this.updateSelectAllStateForSchedule();
    this.filterBy.setValue($event.tabId);
  }

  public onAvailablePlugins(): void {
    this.websiteConnected = false;
      this._dialogService
        .addDialog(AvailablePluginsComponent, {
          website: this.website,
          installedfilteredPlugins: this.plugins,
          pluginScope: this.pluginsScope,
          userPermissions: this.userPermissions,
          userSubscriptions: this._userSubscriptions,
          user: this.user,
          currentSubscription: this.currentSubscription
        });
  }

  public get selectedPlugins(): Product[] {
    if (!this.filteredPlugins) {
      return [];
    }

    return this.filteredPlugins.filter((plugin: Product): boolean => {
      return plugin.selected;
    });
  }

  public productTrackBy(index: number, product: Product) {
    return product.uid;
  }


  public generateScheduleData(cronExpressionString): void {
    this.scheduleCronExpression = cronExpressionString;
  }

  public enableScheduling(value) {
    this.scheduleEnabled = value.currentTarget.checked;
  }

  public enableSchedulingWithBackup(value) {
    this.scheduleWithBackupEnabled = value.currentTarget.checked;
  }

  public onScheduleSubmit(): void {
    this.pluginsScheduleLoading = true;
    const wpPlugins = [];
    const tenWebPlugins = [];
    this.selectedPluginsForSchedule.map( (plugin) => {
      if ( plugin.selected ) {
        if (plugin.origin === '10web' && plugin.paidVersionInstalled) {
          tenWebPlugins.push(plugin.productId);
        }
        else {
          wpPlugins.push(plugin.slug);
        }
      }
    });
    const data = {
      cron_expression: this.scheduleCronExpression,
      backup: this.scheduleWithBackupEnabled ? 1 : 0,
      wp_products: JSON.stringify(wpPlugins),
      tenweb_products: JSON.stringify(tenWebPlugins),
      schedule: this.scheduleEnabled ? 1 : 0,
      type: 'plugin'
    };
    this.updateSchedule(data);
  }


  public updateSchedule(data) {
    this._productService.setSchedulePlugins(this.website.id, data)
    .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.pluginsScheduleLoading = false;
        if (response.success) {
          NotifierComponent.notify(new Notification(response.message, NotificationType.SUCCESS));
          this.getSchedulePlugins();
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  public toggleAllItemsSelectedForSchedule(selected: boolean): void {
    this.pluginsForSchedule.forEach((product: Product): void => {
      product.selected = selected;
    });
  }

  public onItemToggledForSchedule(): void {
    this.updateSelectAllStateForSchedule();
  }

  private updateSelectAllStateForSchedule(): void {
    this.selectAllForSchedule.setValue(this.pluginsForSchedule.length && !this.pluginsForSchedule.find((plugin: Product): boolean => !plugin.selected));
  }

  public get selectedPluginsForSchedule(): Product[] {
    if (!this.pluginsForSchedule) {
      return [];
    }

    return this.pluginsForSchedule.reduce((selectedProducts: Product[], pluginWithAddons: any): Product[] => {
      const plugin: Product = pluginWithAddons;

      if (plugin.selected) {
        selectedProducts.push(plugin);
      }
      return selectedProducts;
    }, []);
  }

  public getSortDirectionClass(sortBy: string) {
    if (sortBy === this.sortBy.value) {
      return 'db-table-sorting-indicator_active db-sort-direction-' + this.sortDirection.value;
    }
    else {
      return 'db-sort-direction-asc';
    }
  }

  public sortTable(sortBy: string, sortDirectionDefault: string = ""): void {
    let sortDirection: string = this.sortDirection.value;
    if (sortDirectionDefault === "") {
      if (sortBy === this.sortBy.value) {
        sortDirection = (sortDirection === 'asc') ? 'desc' : 'asc';
      }
      else {
        sortDirection = this.sortDirectionDefault;
      }
    } else {
      sortDirection = sortDirectionDefault;
    }

    this.sortDirection.setValue(sortDirection);
    this.sortBy.setValue(sortBy);

    this.sortDirectionClassName = 'db-sort-direction-' + sortDirection;
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        first()
      )
      .subscribe((companyInfo: any) => {
        this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
      });
  }

}
